export default ".description {\n  font-size: 11px;\n  margin: 0;\n  padding: 10px;\n}"